export default {
    data() {
        return {
            headers: { Authorization: localStorage.getItem('Authorization')},
            baseUrl: process.env.VUE_APP_ROOT_API,
        }
    },

    methods: {
        imageAPI_delete(fileName) {
            return this.axios.delete(`${this.baseUrl}/api/image/${fileName}`, {headers: this.headers});
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/api/imageAPI.js